import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2e360089")

_pushScopeId("data-v-2e360089")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("设置")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("报告设置")
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-info",
  style: {"color":"#ffa000","margin-right":"5px"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("还原")
const _hoisted_6 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("报告显示设置")
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 核心指标 ")
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 趋势指标 ")
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 屏蔽场景 ")
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 屏蔽设备 ")
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_23 = { style: {"flex-direction":"column","margin-bottom":"0"} }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 详细指标 ")
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("li", null, "基础：", -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_29 = /*#__PURE__*/_createVNode("li", null, "深度：", -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_32 = /*#__PURE__*/_createVNode("li", null, "定制：", -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 指标变化标记阈值 ")
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" % ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 风险评估变化阈值 ")
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 核心指标标红规则 ")
const _hoisted_45 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { style: {"text-align":"right","font-size":"14px","color":"#606466","line-height":"32px"} }, " 只标红变化值 ", -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 核心指标标红规则2 ")
const _hoisted_48 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("p", { style: {"text-align":"right","font-size":"14px","color":"#606466","line-height":"32px"} }, " 变差就变红 ", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("li", null, "允许趋势图数据缺失", -1)
const _hoisted_51 = { style: {"text-align":"center"} }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("允许断点")
const _hoisted_53 = /*#__PURE__*/_createVNode("li", null, "数据详情模块", -1)
const _hoisted_54 = { style: {"text-align":"center"} }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("展示对比数据")
const _hoisted_56 = { key: 0 }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" 测试结论良性指标 ")
const _hoisted_58 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_60 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_61 = { key: 1 }
const _hoisted_62 = /*#__PURE__*/_createVNode("li", null, "测试结论阈值", -1)
const _hoisted_63 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_64 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_65 = { key: 2 }
const _hoisted_66 = /*#__PURE__*/_createVNode("li", null, "测试结论三轮对比阈值", -1)
const _hoisted_67 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_68 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_69 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("TOP机型测试设置")
], -1)
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" 核心指标 ")
const _hoisted_71 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_73 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_74 = /*#__PURE__*/_createVNode("li", null, "一档机型", -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_76 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_77 = /*#__PURE__*/_createVNode("li", null, "二档机型", -1)
const _hoisted_78 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_79 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_80 = /*#__PURE__*/_createVNode("li", null, "三档机型", -1)
const _hoisted_81 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_82 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_83 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("TDR标准设置")
], -1)
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" 选择场景：")
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" 超高端机 ")
const _hoisted_86 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_87 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_88 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_89 = { class: "tdr" }
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" 高端机 ")
const _hoisted_91 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_92 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_93 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" 中端机 ")
const _hoisted_95 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_96 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_97 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" 低端机 ")
const _hoisted_99 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_100 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_101 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_102 = /*#__PURE__*/_createTextVNode(" 超低端机 ")
const _hoisted_103 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_104 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_105 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_106 = /*#__PURE__*/_createTextVNode(" 超高端机 ")
const _hoisted_107 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_108 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_109 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" 高端机 ")
const _hoisted_111 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_112 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_113 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_114 = /*#__PURE__*/_createTextVNode(" 中端机 ")
const _hoisted_115 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_116 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_117 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_118 = /*#__PURE__*/_createTextVNode(" 低端机 ")
const _hoisted_119 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_120 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_121 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_122 = /*#__PURE__*/_createTextVNode(" 超低端机 ")
const _hoisted_123 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_124 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_125 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_126 = /*#__PURE__*/_createTextVNode(" 超高端机 ")
const _hoisted_127 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_128 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_129 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_130 = /*#__PURE__*/_createTextVNode(" 高端机 ")
const _hoisted_131 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_132 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_133 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_134 = /*#__PURE__*/_createTextVNode(" 中端机 ")
const _hoisted_135 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_136 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_137 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_138 = /*#__PURE__*/_createTextVNode(" 低端机 ")
const _hoisted_139 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_140 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_141 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_142 = /*#__PURE__*/_createTextVNode(" 超低端机 ")
const _hoisted_143 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_144 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_145 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_146 = /*#__PURE__*/_createTextVNode(" 超高端机 ")
const _hoisted_147 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_148 = { key: 0 }
const _hoisted_149 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_150 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_151 = { class: "tdr" }
const _hoisted_152 = /*#__PURE__*/_createTextVNode(" 高端机 ")
const _hoisted_153 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_154 = { key: 0 }
const _hoisted_155 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_156 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_157 = /*#__PURE__*/_createTextVNode(" 中端机 ")
const _hoisted_158 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_159 = { key: 0 }
const _hoisted_160 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_161 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_162 = /*#__PURE__*/_createTextVNode(" 低端机 ")
const _hoisted_163 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_164 = { key: 0 }
const _hoisted_165 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_166 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_167 = /*#__PURE__*/_createTextVNode(" 超低端机 ")
const _hoisted_168 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_169 = { key: 0 }
const _hoisted_170 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_171 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_172 = /*#__PURE__*/_createTextVNode(" 超高端机 ")
const _hoisted_173 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_174 = { key: 0 }
const _hoisted_175 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_176 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_177 = /*#__PURE__*/_createTextVNode(" 高端机 ")
const _hoisted_178 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_179 = { key: 0 }
const _hoisted_180 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_181 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_182 = /*#__PURE__*/_createTextVNode(" 中端机 ")
const _hoisted_183 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_184 = { key: 0 }
const _hoisted_185 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_186 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_187 = /*#__PURE__*/_createTextVNode(" 低端机 ")
const _hoisted_188 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_189 = { key: 0 }
const _hoisted_190 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_191 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_192 = /*#__PURE__*/_createTextVNode(" 超低端机 ")
const _hoisted_193 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_194 = { key: 0 }
const _hoisted_195 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_196 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_197 = /*#__PURE__*/_createTextVNode(" 超高端机 ")
const _hoisted_198 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_199 = { key: 0 }
const _hoisted_200 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_201 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_202 = { class: "tdr" }
const _hoisted_203 = /*#__PURE__*/_createTextVNode(" 高端机 ")
const _hoisted_204 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_205 = { key: 0 }
const _hoisted_206 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_207 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_208 = /*#__PURE__*/_createTextVNode(" 中端机 ")
const _hoisted_209 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_210 = { key: 0 }
const _hoisted_211 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_212 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_213 = /*#__PURE__*/_createTextVNode(" 低端机 ")
const _hoisted_214 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_215 = { key: 0 }
const _hoisted_216 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_217 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_218 = /*#__PURE__*/_createTextVNode(" 超低端机 ")
const _hoisted_219 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_220 = { key: 0 }
const _hoisted_221 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_222 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_223 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("报告通知设置")
], -1)
const _hoisted_224 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("报告通知设置")
], -1)
const _hoisted_225 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_226 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_227 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_228 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_229 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_230 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_231 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_232 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_233 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_234 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_235 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_236 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_237 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_238 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_breadcrumb, {
                "separator-class": "el-icon-arrow-right",
                class: "PosTitle"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withId(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_3, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.Tips, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_popconfirm, {
                    "popper-class": "el-popconfirm-style",
                    key: index,
                    title: item.tips,
                    onConfirm: ($event: any) => (_ctx.sumbit(_ctx.Tips[index].confirm))
                  }, {
                    reference: _withId(() => [
                      _createVNode("span", null, [
                        _createVNode(_component_el_tooltip, {
                          effect: "dark",
                          placement: "left"
                        }, {
                          content: _withId(() => [
                            _createVNode("p", {
                              innerHTML: item.Tips
                            }, null, 8, ["innerHTML"])
                          ]),
                          default: _withId(() => [
                            _hoisted_4
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_button, {
                          style: {"margin-right":"15px"},
                          size: "mini",
                          type: "primary",
                          disabled: _ctx.get_is_super
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["title", "onConfirm"]))
                }), 128)),
                _createVNode(_component_el_button, {
                  size: "mini",
                  onClick: _ctx.reduction
                }, {
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_el_divider),
              _withDirectives(_createVNode(_component_el_card, {
                shadow: "never",
                class: "reportDisplay"
              }, {
                default: _withId(() => [
                  _hoisted_6,
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _hoisted_7,
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "测试报告中核心指标表格中呈现的指标",
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("li", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          key: item,
                          effect: "plain",
                          closable: "",
                          onClose: ($event: any) => (_ctx.handleClose(item, 'core_index'))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClose"]))
                      }), 128)),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.report_settings.content.core_index,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.report_settings.content.core_index = $event)),
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: "请选择",
                        style: {"height":"32px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_row, {
                            justify: "space-around",
                            type: "flex"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                class: "select-tag-class",
                                style: {"width":"48%"},
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClearAll('core_index')))
                              }, {
                                default: _withId(() => [
                                  _hoisted_9
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                style: {"width":"48%"},
                                class: "select-tag-class",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSelectAll('core_index', _ctx.get_all_indexes)))
                              }, {
                                default: _withId(() => [
                                  _hoisted_10
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: _ctx.get_all_indexes_cn(item),
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _hoisted_11,
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "测试报告中呈现趋势图的指标",
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("li", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.trend_index, (item) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          key: item,
                          effect: "plain",
                          closable: "",
                          onClose: ($event: any) => (_ctx.handleClose(item, 'trend_index'))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClose"]))
                      }), 128)),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.report_settings.content.trend_index,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.report_settings.content.trend_index = $event)),
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: "请选择",
                        style: {"height":"32px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_row, {
                            justify: "space-around",
                            type: "flex"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                class: "select-tag-class",
                                style: {"width":"48%"},
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleClearAll('trend_index')))
                              }, {
                                default: _withId(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                style: {"width":"48%"},
                                class: "select-tag-class",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSelectAll('trend_index', _ctx.get_all_indexes)))
                              }, {
                                default: _withId(() => [
                                  _hoisted_14
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: _ctx.get_all_indexes_cn(item),
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _hoisted_15,
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "配置的场景不会在测试报告中出现",
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("li", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.exclude_scene, (item) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          key: item,
                          effect: "plain",
                          closable: "",
                          onClose: ($event: any) => (_ctx.handleClose(item, 'exclude_scene'))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.get_scene_chinese(item)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClose"]))
                      }), 128)),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.report_settings.content.exclude_scene,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.report_settings.content.exclude_scene = $event)),
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: "请选择",
                        style: {"height":"32px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_row, {
                            justify: "space-around",
                            type: "flex"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                class: "select-tag-class",
                                style: {"width":"48%"},
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleClearAll('exclude_scene')))
                              }, {
                                default: _withId(() => [
                                  _hoisted_17
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                style: {"width":"48%"},
                                class: "select-tag-class",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSelectAll('exclude_scene', _ctx.getProjectScenes)))
                              }, {
                                default: _withId(() => [
                                  _hoisted_18
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getProjectScenes, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.chinese,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _hoisted_19,
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "配置的设备不会在测试报告中出现",
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("li", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.exclude_device, (item) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          key: item,
                          effect: "plain",
                          closable: "",
                          onClose: ($event: any) => (_ctx.handleClose(item, 'exclude_device'))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.get_device_model(item)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClose"]))
                      }), 128)),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.report_settings.content.exclude_device,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.report_settings.content.exclude_device = $event)),
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: "请选择",
                        style: {"height":"32px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_row, {
                            justify: "space-around",
                            type: "flex"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                class: "select-tag-class",
                                style: {"width":"48%"},
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleClearAll('exclude_device')))
                              }, {
                                default: _withId(() => [
                                  _hoisted_21
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                style: {"width":"48%"},
                                class: "select-tag-class",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSelectAll('exclude_device', _ctx.getDeviceSpecs)))
                              }, {
                                default: _withId(() => [
                                  _hoisted_22
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getDeviceSpecs, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.level + 1 + '档机-' + item.model,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("ul", _hoisted_23, [
                    _createVNode("li", null, [
                      _hoisted_24,
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "测试报告中的详细数据模块会按照配置的指标分类呈现",
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", null, [
                      _createVNode("ul", null, [
                        _hoisted_26,
                        _createVNode("li", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.index_type.basic, (item) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: item,
                              effect: "plain",
                              closable: "",
                              onClose: ($event: any) => (_ctx.handleClose(item, 'basic'))
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClose"]))
                          }), 128)),
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.report_settings.content.index_type.basic,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.report_settings.content.index_type.basic = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "请选择",
                            style: {"height":"32px"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleClearAll('basic')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_27
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleSelectAll('basic', _ctx.get_all_indexes)))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_28
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: _ctx.get_all_indexes_cn(item),
                                  value: item,
                                  disabled: _ctx.get_detailed_indexes('basic', item)
                                }, null, 8, ["label", "value", "disabled"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createVNode("ul", null, [
                        _hoisted_29,
                        _createVNode("li", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.index_type.advance, (item) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: item,
                              effect: "plain",
                              closable: "",
                              onClose: ($event: any) => (_ctx.handleClose(item, 'advance'))
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClose"]))
                          }), 128)),
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.report_settings.content.index_type.advance,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.report_settings.content.index_type.advance = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "请选择",
                            style: {"height":"32px"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleClearAll('advance')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_30
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleSelectAll('advance', _ctx.get_all_indexes)))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_31
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: _ctx.get_all_indexes_cn(item),
                                  value: item,
                                  disabled: _ctx.get_detailed_indexes('advance', item)
                                }, null, 8, ["label", "value", "disabled"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createVNode("ul", null, [
                        _hoisted_32,
                        _createVNode("li", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.index_type.customize, (item) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: item,
                              effect: "plain",
                              closable: "",
                              onClose: ($event: any) => (_ctx.handleClose(item, 'customize'))
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClose"]))
                          }), 128)),
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.report_settings.content.index_type.customize,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.report_settings.content.index_type.customize = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "请选择",
                            style: {"height":"32px"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleClearAll('customize')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_33
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleSelectAll('customize', _ctx.get_all_indexes)))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_34
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: _ctx.get_all_indexes_cn(item),
                                  value: item,
                                  disabled: _ctx.get_detailed_indexes('customize', item)
                                }, null, 8, ["label", "value", "disabled"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _hoisted_35,
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "当指标变化超过配置的阈值才会标记红绿颜色，默认任意变化都会标记",
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _hoisted_36
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("li", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.Threshold, (item) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          key: item,
                          effect: "plain",
                          closable: "",
                          onClose: ($event: any) => (_ctx.handleClose2(item, 'Threshold'))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": ($event: any) => (_ctx.rule_settings.change_rule.threshold[item] = $event),
                              placeholder: _ctx.rule_settings.change_rule.threshold[item],
                              class: "riskRule_input_value"
                            }, null, 8, ["onUpdate:modelValue", "placeholder"]), [
                              [_vModelText, _ctx.rule_settings.change_rule.threshold[item]]
                            ]),
                            _hoisted_37
                          ]),
                          _: 2
                        }, 1032, ["onClose"]))
                      }), 128)),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.Threshold,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.Threshold = $event)),
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: "请选择",
                        style: {"height":"32px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_row, {
                            justify: "space-around",
                            type: "flex"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                class: "select-tag-class",
                                style: {"width":"48%"},
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleClearAll2('Threshold')))
                              }, {
                                default: _withId(() => [
                                  _hoisted_38
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                style: {"width":"48%"},
                                class: "select-tag-class",
                                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleSelectAll2('Threshold')))
                              }, {
                                default: _withId(() => [
                                  _hoisted_39
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: _ctx.get_all_indexes_cn(item),
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _hoisted_40,
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "当指标变差超过配置的阈值则为高风险，否则为低风险，不配置则变差任意数值均为高风险。仅配置为核心指标的才有风险结论。",
                        placement: "top",
                        "popper-class": "darkContent"
                      }, {
                        default: _withId(() => [
                          _hoisted_41
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("li", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.riskRule, (item) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          key: item,
                          effect: "plain",
                          closable: "",
                          onClose: ($event: any) => (_ctx.handleClose2(item, 'riskRule'))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": ($event: any) => (_ctx.rule_settings.risk_rule[item] = $event),
                              placeholder: _ctx.rule_settings.risk_rule[item],
                              class: "riskRule_input_value"
                            }, null, 8, ["onUpdate:modelValue", "placeholder"]), [
                              [_vModelText, _ctx.rule_settings.risk_rule[item]]
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClose"]))
                      }), 128)),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.riskRule,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.riskRule = $event)),
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: "请选择",
                        style: {"height":"32px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_row, {
                            justify: "space-around",
                            type: "flex"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                class: "select-tag-class",
                                style: {"width":"48%"},
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleClearAll2('riskRule')))
                              }, {
                                default: _withId(() => [
                                  _hoisted_42
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                style: {"width":"48%"},
                                class: "select-tag-class",
                                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handleSelectAll2('riskRule')))
                              }, {
                                default: _withId(() => [
                                  _hoisted_43
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: _ctx.get_all_indexes_cn(item),
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _hoisted_44,
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "核心指标风险详情表格, 里面只标红括号内变化的值",
                        placement: "top",
                        "popper-class": "darkContent"
                      }, {
                        default: _withId(() => [
                          _hoisted_45
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("li", null, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.report_settings.content.red_only_change_value,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.report_settings.content.red_only_change_value = $event))
                      }, {
                        default: _withId(() => [
                          _hoisted_46
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _hoisted_47,
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "勾选代表变差就标红,  否则超过阈值才标红",
                        placement: "top",
                        "popper-class": "darkContent"
                      }, {
                        default: _withId(() => [
                          _hoisted_48
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("li", null, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.report_settings.content.core_color_rule,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.report_settings.content.core_color_rule = $event))
                      }, {
                        default: _withId(() => [
                          _hoisted_49
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("ul", null, [
                    _hoisted_50,
                    _createVNode("li", _hoisted_51, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.report_settings.content.trend_integrity,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.report_settings.content.trend_integrity = $event))
                      }, {
                        default: _withId(() => [
                          _hoisted_52
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("ul", null, [
                    _hoisted_53,
                    _createVNode("li", _hoisted_54, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.report_settings.content.is_have_old,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.report_settings.content.is_have_old = $event))
                      }, {
                        default: _withId(() => [
                          _hoisted_55
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  (_ctx.aovShow)
                    ? (_openBlock(), _createBlock("ul", _hoisted_56, [
                        _createVNode("li", null, [
                          _hoisted_57,
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "在这里配置的指标，上升为好的情况，否则降低视为好的情况",
                            placement: "top",
                            "popper-class": "darkContent"
                          }, {
                            default: _withId(() => [
                              _hoisted_58
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("li", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.common_aov
                  .increase_good, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: index,
                              effect: "plain",
                              closable: "",
                              onClose: ($event: any) => (_ctx.handleClose3(index))
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClose"]))
                          }), 128)),
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.report_settings.common_aov.increase_good,
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.report_settings.common_aov.increase_good = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "请选择",
                            style: {"height":"32px"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handleClearAll3('aov')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_59
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.handleSelectAll3('aov')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_60
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.testData, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.aovShow)
                    ? (_openBlock(), _createBlock("ul", _hoisted_61, [
                        _hoisted_62,
                        _createVNode("li", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aov, (item) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: item,
                              effect: "plain",
                              closable: "",
                              onClose: ($event: any) => (_ctx.handleClose4('aov', item))
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item) + ": ", 1),
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => (_ctx.report_settings.aov[item] = $event),
                                  placeholder: _ctx.report_settings.aov[item],
                                  class: "riskRule_input_value"
                                }, null, 8, ["onUpdate:modelValue", "placeholder"]), [
                                  [_vModelText, _ctx.report_settings.aov[item]]
                                ])
                              ]),
                              _: 2
                            }, 1032, ["onClose"]))
                          }), 128)),
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.aov,
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.aov = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "请选择",
                            style: {"height":"32px"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.handleClearAll4('aov')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_63
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.handleSelectAll4('aov')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_64
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.testData, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.aovShow)
                    ? (_openBlock(), _createBlock("ul", _hoisted_65, [
                        _hoisted_66,
                        _createVNode("li", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aov3, (item) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: item,
                              effect: "plain",
                              closable: "",
                              onClose: ($event: any) => (_ctx.handleClose4('aov_3', item))
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item) + ": ", 1),
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => (_ctx.report_settings.aov_3[item] = $event),
                                  placeholder: _ctx.report_settings.aov_3[item],
                                  class: "riskRule_input_value"
                                }, null, 8, ["onUpdate:modelValue", "placeholder"]), [
                                  [_vModelText, _ctx.report_settings.aov_3[item]]
                                ])
                              ]),
                              _: 2
                            }, 1032, ["onClose"]))
                          }), 128)),
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.aov3,
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.aov3 = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "请选择",
                            style: {"height":"32px"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.handleClearAll4('aov_3')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_67
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.handleSelectAll4('aov_3')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_68
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.testData, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512), [
                [_directive_loading, _ctx.loading]
              ]),
              (_ctx.topShow)
                ? (_openBlock(), _createBlock(_component_el_card, {
                    key: 0,
                    class: "reportDisplay"
                  }, {
                    default: _withId(() => [
                      _hoisted_69,
                      _createVNode("ul", null, [
                        _createVNode("li", null, [
                          _hoisted_70,
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "在这里配置的指标，上升为好的情况，否则降低视为好的情况",
                            placement: "top",
                            "popper-class": "darkContent"
                          }, {
                            default: _withId(() => [
                              _hoisted_71
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("li", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.top.core_index, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: index,
                              effect: "plain",
                              closable: "",
                              onClose: ($event: any) => (_ctx.handleClose5(item))
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClose"]))
                          }), 128)),
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.report_settings.top.core_index,
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.report_settings.top.core_index = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "请选择",
                            style: {"height":"32px"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"}
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_72
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_73
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createVNode("ul", null, [
                        _hoisted_74,
                        _createVNode("li", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.firstModel, (item) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: item,
                              effect: "plain",
                              closable: "",
                              onClose: ($event: any) => (_ctx.handleClose6('level_1', item)),
                              onChange: _ctx.hh
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item) + ": ", 1),
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => (_ctx.report_settings.top.risk_rule.Android.level_1[item] = $event),
                                  placeholder: 
                    _ctx.report_settings.top.risk_rule.Android.level_1[item]
                  ,
                                  class: "riskRule_input_value"
                                }, null, 8, ["onUpdate:modelValue", "placeholder"]), [
                                  [_vModelText, _ctx.report_settings.top.risk_rule.Android.level_1[item]]
                                ])
                              ]),
                              _: 2
                            }, 1032, ["onClose", "onChange"]))
                          }), 128)),
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.firstModel,
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.firstModel = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "请选择",
                            style: {"height":"32px"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.handleClearAll5('level_1')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_75
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.handleSelectAll5('leavel_1', _ctx.get_all_indexes)))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_76
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createVNode("ul", null, [
                        _hoisted_77,
                        _createVNode("li", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.secondModel, (item) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: item,
                              effect: "plain",
                              closable: "",
                              onClose: ($event: any) => (_ctx.handleClose6('level_2', item))
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item) + ": ", 1),
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => (_ctx.report_settings.top.risk_rule.Android.level_2[item] = $event),
                                  placeholder: 
                    _ctx.report_settings.top.risk_rule.Android.level_2[item]
                  ,
                                  class: "riskRule_input_value"
                                }, null, 8, ["onUpdate:modelValue", "placeholder"]), [
                                  [_vModelText, _ctx.report_settings.top.risk_rule.Android.level_2[item]]
                                ])
                              ]),
                              _: 2
                            }, 1032, ["onClose"]))
                          }), 128)),
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.secondModel,
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.secondModel = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "请选择",
                            style: {"height":"32px"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.handleClearAll5('level_2')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_78
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.handleSelectAll5('leavel_2', _ctx.get_all_indexes)))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_79
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createVNode("ul", null, [
                        _hoisted_80,
                        _createVNode("li", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thirdModel, (item) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: item,
                              effect: "plain",
                              closable: "",
                              onClose: ($event: any) => (_ctx.handleClose6('level_3', item))
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item) + ": ", 1),
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => (_ctx.report_settings.top.risk_rule.Android.level_3[item] = $event),
                                  placeholder: 
                    _ctx.report_settings.top.risk_rule.Android.level_3[item]
                  ,
                                  class: "riskRule_input_value"
                                }, null, 8, ["onUpdate:modelValue", "placeholder"]), [
                                  [_vModelText, _ctx.report_settings.top.risk_rule.Android.level_3[item]]
                                ])
                              ]),
                              _: 2
                            }, 1032, ["onClose"]))
                          }), 128)),
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.thirdModel,
                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.thirdModel = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "请选择",
                            style: {"height":"32px"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.handleClearAll5('level_3')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_81
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.handleSelectAll5('leavel_3', _ctx.get_all_indexes)))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_82
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_card, { class: "reportDisplay" }, {
                default: _withId(() => [
                  _hoisted_83,
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _hoisted_84,
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.scene_id,
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.scene_id = $event)),
                        onChange: _cache[52] || (_cache[52] = ($event: any) => (_ctx.ruleChange(_ctx.scene_id))),
                        placeholder: "请选择",
                        style: {"height":"32px"}
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ProjectScenes, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.chinese,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  (_ctx.scene_id == 9999)
                    ? (_openBlock(), _createBlock(_component_el_tabs, {
                        key: 0,
                        type: "card"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tab_pane, { label: "安卓" }, {
                            default: _withId(() => [
                              _createVNode("div", null, [
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_85,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_86
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrZeroModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrZeroModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule.Android.level_0[item]
                         = $event),
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue"]), [
                                            [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule.Android.level_0[item]
                        ]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrZeroModel,
                                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (_ctx.tdrZeroModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.handleClearAll2('tdrZeroModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_87
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.handleSelectAll2('tdrZeroModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_88
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("ul", _hoisted_89, [
                                  _createVNode("li", null, [
                                    _hoisted_90,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_91
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrFirstModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrFirstModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule.Android.level_1[item]
                         = $event),
                                            placeholder: 
                          _ctx.rule_settings.tdr_risk_rule.Android.level_1[item]
                        ,
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue", "placeholder"]), [
                                            [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule.Android.level_1[item]
                        ]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrFirstModel,
                                      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (_ctx.tdrFirstModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.handleClearAll2('tdrFirstModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_92
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.handleSelectAll2('tdrFirstModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_93
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_94,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_95
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrSecondModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrSecondModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule.Android.level_2[item]
                         = $event),
                                            placeholder: 
                          _ctx.rule_settings.tdr_risk_rule.Android.level_2[item]
                        ,
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue", "placeholder"]), [
                                            [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule.Android.level_2[item]
                        ]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrSecondModel,
                                      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (_ctx.tdrSecondModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.handleClearAll2('tdrSecondModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_96
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.handleSelectAll2('tdrSecondModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_97
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_98,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_99
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrThirdModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrThirdModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule.Android.level_3[item]
                         = $event),
                                            placeholder: 
                          _ctx.rule_settings.tdr_risk_rule.Android.level_3[item]
                        ,
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue", "placeholder"]), [
                                            [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule.Android.level_3[item]
                        ]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrThirdModel,
                                      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (_ctx.tdrThirdModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.handleClearAll2('tdrThirdModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_100
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.handleSelectAll2('tdrThirdModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_101
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_102,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_103
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrFourthModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrFourthModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule.Android.level_4[item]
                         = $event),
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue"]), [
                                            [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule.Android.level_4[item]
                        ]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrFourthModel,
                                      "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => (_ctx.tdrFourthModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.handleClearAll2('tdrFourthModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_104
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.handleSelectAll2('tdrFourthModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_105
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_tab_pane, { label: "IOS" }, {
                            default: _withId(() => [
                              _createVNode("div", null, [
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_106,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_107
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrIosZeroModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrIosZeroModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (_ctx.rule_settings.tdr_risk_rule.iOS.level_0[item] = $event),
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue"]), [
                                            [_vModelText, _ctx.rule_settings.tdr_risk_rule.iOS.level_0[item]]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrIosZeroModel,
                                      "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => (_ctx.tdrIosZeroModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.handleClearAll2('tdrIosZeroModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_108
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.handleSelectAll2('tdrIosZeroModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_109
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_110,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_111
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrIosFirstModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrIosFirstModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (_ctx.rule_settings.tdr_risk_rule.iOS.level_1[item] = $event),
                                            placeholder: 
                          _ctx.rule_settings.tdr_risk_rule.iOS.level_1[item]
                        ,
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue", "placeholder"]), [
                                            [_vModelText, _ctx.rule_settings.tdr_risk_rule.iOS.level_1[item]]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrIosFirstModel,
                                      "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => (_ctx.tdrIosFirstModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.handleClearAll2('tdrIosFirstModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_112
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.handleSelectAll2('tdrIosFirstModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_113
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_114,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_115
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrIosSecondModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrIosSecondModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (_ctx.rule_settings.tdr_risk_rule.iOS.level_2[item] = $event),
                                            placeholder: 
                          _ctx.rule_settings.tdr_risk_rule.iOS.level_2[item]
                        ,
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue", "placeholder"]), [
                                            [_vModelText, _ctx.rule_settings.tdr_risk_rule.iOS.level_2[item]]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrIosSecondModel,
                                      "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => (_ctx.tdrIosSecondModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.handleClearAll2('tdrIosSecondModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_116
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.handleSelectAll2('tdrIosSecondModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_117
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_118,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_119
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrIosThirdModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrIosThirdModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (_ctx.rule_settings.tdr_risk_rule.iOS.level_3[item] = $event),
                                            placeholder: 
                          _ctx.rule_settings.tdr_risk_rule.iOS.level_3[item]
                        ,
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue", "placeholder"]), [
                                            [_vModelText, _ctx.rule_settings.tdr_risk_rule.iOS.level_3[item]]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrIosThirdModel,
                                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => (_ctx.tdrIosThirdModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.handleClearAll2('tdrIosThirdModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_120
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.handleSelectAll2('tdrIosThirdModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_121
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_122,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_123
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrIosfourthModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrIosfourthModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (_ctx.rule_settings.tdr_risk_rule.iOS.level_4[item] = $event),
                                            placeholder: 
                          _ctx.rule_settings.tdr_risk_rule.iOS.level_4[item]
                        ,
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue", "placeholder"]), [
                                            [_vModelText, _ctx.rule_settings.tdr_risk_rule.iOS.level_4[item]]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrIosfourthModel,
                                      "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => (_ctx.tdrIosfourthModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.handleClearAll2('tdrIosfourthModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_124
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.handleSelectAll2('tdrIosfourthModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_125
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_tab_pane, { label: "PC" }, {
                            default: _withId(() => [
                              _createVNode("div", null, [
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_126,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_127
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrPcZeroModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrPcZeroModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (_ctx.rule_settings.tdr_risk_rule.PC.level_0[item] = $event),
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue"]), [
                                            [_vModelText, _ctx.rule_settings.tdr_risk_rule.PC.level_0[item]]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrPcZeroModel,
                                      "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => (_ctx.tdrPcZeroModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.handleClearAll2('tdrPcZeroModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_128
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.handleSelectAll2('tdrPcZeroModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_129
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_130,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_131
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrPcFirstModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrPcFirstModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (_ctx.rule_settings.tdr_risk_rule.PC.level_1[item] = $event),
                                            placeholder: 
                          _ctx.rule_settings.tdr_risk_rule.PC.level_1[item]
                        ,
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue", "placeholder"]), [
                                            [_vModelText, _ctx.rule_settings.tdr_risk_rule.PC.level_1[item]]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrPcFirstModel,
                                      "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => (_ctx.tdrPcFirstModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.handleClearAll2('tdrPcFirstModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_132
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[87] || (_cache[87] = ($event: any) => (_ctx.handleSelectAll2('tdrPcFirstModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_133
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_134,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_135
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrPcSecondModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrPcSecondModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (_ctx.rule_settings.tdr_risk_rule.PC.level_2[item] = $event),
                                            placeholder: 
                          _ctx.rule_settings.tdr_risk_rule.PC.level_2[item]
                        ,
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue", "placeholder"]), [
                                            [_vModelText, _ctx.rule_settings.tdr_risk_rule.PC.level_2[item]]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrPcSecondModel,
                                      "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => (_ctx.tdrPcSecondModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.handleClearAll2('tdrPcSecondModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_136
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.handleSelectAll2('tdrPcSecondModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_137
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_138,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_139
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrPcThirdModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrPcThirdModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (_ctx.rule_settings.tdr_risk_rule.PC.level_3[item] = $event),
                                            placeholder: 
                          _ctx.rule_settings.tdr_risk_rule.PC.level_3[item]
                        ,
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue", "placeholder"]), [
                                            [_vModelText, _ctx.rule_settings.tdr_risk_rule.PC.level_3[item]]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrPcThirdModel,
                                      "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => (_ctx.tdrPcThirdModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.handleClearAll2('tdrPcThirdModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_140
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[93] || (_cache[93] = ($event: any) => (_ctx.handleSelectAll2('tdrPcThirdModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_141
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_142,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_143
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("li", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrPcFourthModel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: item,
                                        effect: "plain",
                                        closable: "",
                                        onClose: ($event: any) => (_ctx.handleClose2(item, 'tdrPcFourthModel'))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                          _withDirectives(_createVNode("input", {
                                            style: { width: item == 'max_pss' ? '30px' : '25px' },
                                            "onUpdate:modelValue": ($event: any) => (_ctx.rule_settings.tdr_risk_rule.PC.level_4[item] = $event),
                                            placeholder: 
                          _ctx.rule_settings.tdr_risk_rule.PC.level_4[item]
                        ,
                                            class: "riskRule_input_value"
                                          }, null, 12, ["onUpdate:modelValue", "placeholder"]), [
                                            [_vModelText, _ctx.rule_settings.tdr_risk_rule.PC.level_4[item]]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClose"]))
                                    }), 128)),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.tdrPcFourthModel,
                                      "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => (_ctx.tdrPcFourthModel = $event)),
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择",
                                      style: {"height":"32px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_row, {
                                          justify: "space-around",
                                          type: "flex"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              class: "select-tag-class",
                                              style: {"width":"48%"},
                                              onClick: _cache[95] || (_cache[95] = ($event: any) => (_ctx.handleClearAll2('tdrPcFourthModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_144
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_tag, {
                                              type: "primary",
                                              style: {"width":"48%"},
                                              class: "select-tag-class",
                                              onClick: _cache[96] || (_cache[96] = ($event: any) => (_ctx.handleSelectAll2('tdrPcFourthModel')))
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_145
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: _ctx.get_all_indexes_cn(item),
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_tabs, {
                        key: 1,
                        type: "card"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tab_pane, { label: "安卓" }, {
                            default: _withId(() => [
                              _createVNode("div", null, [
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_146,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_147
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_148, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrZeroModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrZeroModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].Android.level_0[
                            item
                          ]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].Android.level_0[
                            item
                          ]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrZeroModel1,
                                          "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => (_ctx.tdrZeroModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[98] || (_cache[98] = ($event: any) => (_ctx.handleClearAll7('tdrZeroModel1', _ctx.scene_id)))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_149
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[99] || (_cache[99] = ($event: any) => (_ctx.handleSelectAll2('tdrZeroModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_150
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("ul", _hoisted_151, [
                                  _createVNode("li", null, [
                                    _hoisted_152,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_153
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_154, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrFirstModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrFirstModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].Android.level_1[
                            item
                          ]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].Android.level_1[
                            item
                          ]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrFirstModel1,
                                          "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => (_ctx.tdrFirstModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[101] || (_cache[101] = ($event: any) => (_ctx.handleClearAll7('tdrFirstModel1', _ctx.scene_id)))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_155
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[102] || (_cache[102] = ($event: any) => (_ctx.handleSelectAll2('tdrFirstModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_156
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_157,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_158
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_159, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrSecondModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrSecondModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].Android.level_2[
                            item
                          ]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].Android.level_2[
                            item
                          ]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrSecondModel1,
                                          "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event: any) => (_ctx.tdrSecondModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[104] || (_cache[104] = ($event: any) => (_ctx.handleClearAll7('tdrSecondModel1', _ctx.scene_id)))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_160
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[105] || (_cache[105] = ($event: any) => (_ctx.handleSelectAll2('tdrSecondModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_161
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_162,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_163
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_164, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrThirdModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrThirdModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].Android.level_3[
                            item
                          ]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].Android.level_3[
                            item
                          ]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrThirdModel1,
                                          "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => (_ctx.tdrThirdModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[107] || (_cache[107] = ($event: any) => (_ctx.handleClearAll7('tdrThirdModel1', _ctx.scene_id)))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_165
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[108] || (_cache[108] = ($event: any) => (_ctx.handleSelectAll2('tdrThirdModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_166
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_167,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_168
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_169, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrFourthModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrFourthModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].Android.level_4[
                            item
                          ]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].Android.level_4[
                            item
                          ]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrFourthModel1,
                                          "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => (_ctx.tdrFourthModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[110] || (_cache[110] = ($event: any) => (_ctx.handleClearAll7('tdrFourthModel1', _ctx.scene_id)))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_170
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[111] || (_cache[111] = ($event: any) => (_ctx.handleSelectAll2('tdrFourthModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_171
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_tab_pane, { label: "IOS" }, {
                            default: _withId(() => [
                              _createVNode("div", null, [
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_172,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_173
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_174, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrIosZeroModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrIosZeroModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].iOS.level_0[
                            item
                          ]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].iOS.level_0[
                            item
                          ]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrIosZeroModel1,
                                          "onUpdate:modelValue": _cache[115] || (_cache[115] = ($event: any) => (_ctx.tdrIosZeroModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[113] || (_cache[113] = ($event: any) => (_ctx.handleClearAll7('tdrIosZeroModel1', _ctx.scene_id)))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_175
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[114] || (_cache[114] = ($event: any) => (_ctx.handleSelectAll2('tdrIosZeroModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_176
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_177,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_178
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_179, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrIosFirstModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrIosFirstModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].iOS.level_1[
                            item
                          ]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].iOS.level_1[
                            item
                          ]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrIosFirstModel1,
                                          "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event: any) => (_ctx.tdrIosFirstModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[116] || (_cache[116] = ($event: any) => (
                            _ctx.handleClearAll7('tdrIosFirstModel1', _ctx.scene_id)
                          ))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_180
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[117] || (_cache[117] = ($event: any) => (_ctx.handleSelectAll2('tdrIosFirstModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_181
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_182,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_183
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_184, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrIosSecondModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (
                        _ctx.handleClose7(item, 'tdrIosSecondModel1', _ctx.scene_id)
                      )
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].iOS.level_2[
                            item
                          ]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].iOS.level_2[
                            item
                          ]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrIosSecondModel1,
                                          "onUpdate:modelValue": _cache[121] || (_cache[121] = ($event: any) => (_ctx.tdrIosSecondModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[119] || (_cache[119] = ($event: any) => (
                            _ctx.handleClearAll7('tdrIosSecondModel1', _ctx.scene_id)
                          ))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_185
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[120] || (_cache[120] = ($event: any) => (_ctx.handleSelectAll2('tdrIosSecondModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_186
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_187,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_188
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_189, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrIosThirdModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrIosThirdModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].iOS.level_3[
                            item
                          ]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].iOS.level_3[
                            item
                          ]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrIosThirdModel1,
                                          "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => (_ctx.tdrIosThirdModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[122] || (_cache[122] = ($event: any) => (
                            _ctx.handleClearAll7('tdrIosThirdModel1', _ctx.scene_id)
                          ))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_190
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[123] || (_cache[123] = ($event: any) => (_ctx.handleSelectAll2('tdrIosThirdModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_191
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_192,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_193
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_194, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrIosfourthModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (
                        _ctx.handleClose7(item, 'tdrIosfourthModel1', _ctx.scene_id)
                      )
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].iOS.level_4[
                            item
                          ]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].iOS.level_4[
                            item
                          ]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrIosfourthModel1,
                                          "onUpdate:modelValue": _cache[127] || (_cache[127] = ($event: any) => (_ctx.tdrIosfourthModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[125] || (_cache[125] = ($event: any) => (
                            _ctx.handleClearAll7('tdrIosfourthModel1', _ctx.scene_id)
                          ))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_195
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[126] || (_cache[126] = ($event: any) => (_ctx.handleSelectAll2('tdrIosfourthModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_196
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_tab_pane, { label: "PC" }, {
                            default: _withId(() => [
                              _createVNode("div", null, [
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_197,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_198
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_199, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrPcZeroModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrPcZeroModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].PC.level_0[item]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].PC.level_0[item]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrPcZeroModel1,
                                          "onUpdate:modelValue": _cache[130] || (_cache[130] = ($event: any) => (_ctx.tdrPcZeroModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[128] || (_cache[128] = ($event: any) => (_ctx.handleClearAll7('tdrPcZeroModel1', _ctx.scene_id)))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_200
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[129] || (_cache[129] = ($event: any) => (_ctx.handleSelectAll2('tdrPcZeroModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_201
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("ul", _hoisted_202, [
                                  _createVNode("li", null, [
                                    _hoisted_203,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_204
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_205, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrPcFirstModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrPcFirstModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].PC.level_1[item]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].PC.level_1[item]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrPcFirstModel1,
                                          "onUpdate:modelValue": _cache[133] || (_cache[133] = ($event: any) => (_ctx.tdrPcFirstModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[131] || (_cache[131] = ($event: any) => (_ctx.handleClearAll7('tdrPcFirstModel1', _ctx.scene_id)))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_206
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[132] || (_cache[132] = ($event: any) => (_ctx.handleSelectAll2('tdrPcFirstModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_207
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_208,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_209
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_210, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrPcSecondModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrPcSecondModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].PC.level_2[item]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].PC.level_2[item]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrPcSecondModel1,
                                          "onUpdate:modelValue": _cache[136] || (_cache[136] = ($event: any) => (_ctx.tdrPcSecondModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[134] || (_cache[134] = ($event: any) => (
                            _ctx.handleClearAll7('tdrPcSecondModel1', _ctx.scene_id)
                          ))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_211
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[135] || (_cache[135] = ($event: any) => (_ctx.handleSelectAll2('tdrPcSecondModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_212
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_213,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_214
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_215, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrPcThirdModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrPcThirdModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].PC.level_3[item]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].PC.level_3[item]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrPcThirdModel1,
                                          "onUpdate:modelValue": _cache[139] || (_cache[139] = ($event: any) => (_ctx.tdrPcThirdModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[137] || (_cache[137] = ($event: any) => (_ctx.handleClearAll7('tdrPcThirdModel1', _ctx.scene_id)))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_216
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[138] || (_cache[138] = ($event: any) => (_ctx.handleSelectAll2('tdrPcThirdModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_217
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _hoisted_218,
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "指标风险绝对值评估规则,指标高于或低于绝对值视为高风险",
                                      placement: "top",
                                      "popper-class": "darkContent"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_219
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock("li", _hoisted_220, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tdrPcFourthModel1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: item,
                                            effect: "plain",
                                            closable: "",
                                            onClose: ($event: any) => (_ctx.handleClose7(item, 'tdrPcFourthModel1', _ctx.scene_id))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.get_all_indexes_cn(item)) + ": ", 1),
                                              _withDirectives(_createVNode("input", {
                                                style: { width: item == 'max_pss' ? '30px' : '25px' },
                                                "onUpdate:modelValue": ($event: any) => (
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].PC.level_4[item]
                         = $event),
                                                class: "riskRule_input_value"
                                              }, null, 12, ["onUpdate:modelValue"]), [
                                                [_vModelText, 
                          _ctx.rule_settings.tdr_risk_rule[_ctx.scene_id].PC.level_4[item]
                        ]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClose"]))
                                        }), 128)),
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tdrPcFourthModel1,
                                          "onUpdate:modelValue": _cache[142] || (_cache[142] = ($event: any) => (_ctx.tdrPcFourthModel1 = $event)),
                                          multiple: "",
                                          "collapse-tags": "",
                                          placeholder: "请选择",
                                          style: {"height":"32px"}
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_row, {
                                              justify: "space-around",
                                              type: "flex"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  class: "select-tag-class",
                                                  style: {"width":"48%"},
                                                  onClick: _cache[140] || (_cache[140] = ($event: any) => (
                            _ctx.handleClearAll7('tdrPcFourthModel1', _ctx.scene_id)
                          ))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_221
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_tag, {
                                                  type: "primary",
                                                  style: {"width":"48%"},
                                                  class: "select-tag-class",
                                                  onClick: _cache[141] || (_cache[141] = ($event: any) => (_ctx.handleSelectAll2('tdrPcFourthModel1')))
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_222
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content.core_index, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: _ctx.get_all_indexes_cn(item),
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_el_card, {
                shadow: "never",
                class: "reportNotification"
              }, {
                default: _withId(() => [
                  _hoisted_223,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.custom,
                    "onUpdate:modelValue": _cache[143] || (_cache[143] = ($event: any) => (_ctx.custom = $event)),
                    rows: 4,
                    type: "textarea",
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 512), [
                [_directive_loading, _ctx.loading]
              ]),
              _withDirectives(_createVNode(_component_el_card, {
                shadow: "never",
                class: "reportNotification"
              }, {
                default: _withId(() => [
                  _hoisted_224,
                  _createVNode(_component_el_form, null, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "是否发送邮件报告" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_checkbox, {
                            modelValue: _ctx.report_settings.notify.email.enable,
                            "onUpdate:modelValue": _cache[144] || (_cache[144] = ($event: any) => (_ctx.report_settings.notify.email.enable = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "邮件报告收件人" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                            content: _withId(() => [
                              _hoisted_225,
                              _hoisted_226,
                              _hoisted_227,
                              _hoisted_228,
                              _hoisted_229,
                              _hoisted_230,
                              _hoisted_231
                            ]),
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.report_settings.notify.email.receiver_str,
                                "onUpdate:modelValue": _cache[145] || (_cache[145] = ($event: any) => (_ctx.report_settings.notify.email.receiver_str = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form, null, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "是否发送企业微信通知" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_checkbox, {
                            modelValue: _ctx.report_settings.notify.wecom.enable,
                            "onUpdate:modelValue": _cache[146] || (_cache[146] = ($event: any) => (_ctx.report_settings.notify.wecom.enable = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "企业微信收件人" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                            content: _withId(() => [
                              _hoisted_232,
                              _hoisted_233,
                              _hoisted_234,
                              _hoisted_235,
                              _hoisted_236,
                              _hoisted_237,
                              _hoisted_238
                            ]),
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.report_settings.notify.wecom.receiver_str,
                                "onUpdate:modelValue": _cache[147] || (_cache[147] = ($event: any) => (_ctx.report_settings.notify.wecom.receiver_str = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_directive_loading, _ctx.loading]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})